import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { faCalendarAlt, faLoveseat, faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { AppSettings } from 'src/app/app-settings';
import { CartService } from 'src/app/services/cart.service';
import {
  AppearanceAnimation,
  ButtonLayoutDisplay,
  ButtonMaker,
  DialogInitializer,
  DialogLayoutDisplay,
  DisappearanceAnimation,
} from '@costlydeveloper/ngx-awesome-popup';
import { DialogDeletePassComponent } from '../dialog-delete-pass/dialog-delete-pass.component';

@Component({
  selector: 'app-resume-event-card',
  templateUrl: './resume-event-card.component.html',
  styleUrls: ['./resume-event-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResumeEventCardComponent implements OnInit {
  @Output() ticketRemoved = new EventEmitter<any>();
  @Input() cartLine: any;
  @Input() position: any;
  faTrashcan = faTrashAlt;
  faCalendar = faCalendarAlt;
  faSeat = faLoveseat;
  urlImages = AppSettings.API_EVENTS_ASSETS;
  removing = false;

  constructor(private cartService: CartService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void { 
  }

  removeTicketCart() {
    const isAbono = this.cartLine?.id_discount || this.cartLine?.discount;
    if (isAbono) {
      this.openDeletePassDialog();
      return;
    }
    this.doRemove();
  }

  private openDeletePassDialog() {
    const discountId = this.cartLine?.id_discount || this.cartLine?.discount?.id;
    const passName = this.cartLine?.discount?.name || 'este abono';
    const dialogPopup = new DialogInitializer(DialogDeletePassComponent);
    dialogPopup.setCustomData({ discountId, passName, cartLine: this.cartLine });
    dialogPopup.setConfig({
      layoutType: DialogLayoutDisplay.NONE,
      animationIn: AppearanceAnimation.NONE,
      animationOut: DisappearanceAnimation.NONE,
    });
    dialogPopup.setButtons([
      new ButtonMaker('Cancelar', 'cancel', ButtonLayoutDisplay.SECONDARY),
      new ButtonMaker('Eliminar entradas', 'confirm', ButtonLayoutDisplay.DANGER),
    ]);
    dialogPopup.openDialog$().subscribe(resp => {
      if (resp.success) {
        this.emmitTicketRemoved(this.cartLine.id);
      }
    });
  }

  private doRemove() {
    this.removing = true;
    this.cdr.markForCheck();
    const bookings = this.cartLine.bookings.map((booking: any) => booking.id_seat);
    this.cartService.deleteItemToCart(this.cartLine.id, bookings).subscribe({
      next: () => {
        this.cartService.getCart().subscribe();
        this.emmitTicketRemoved(this.cartLine.id);
      },
      error: (err) => {
        this.removing = false;
        this.cdr.markForCheck();
        console.error('[doRemove] Error al eliminar línea del carrito:', err);
      }
    });
  }

  emmitTicketRemoved(seat: any) {
    this.ticketRemoved.emit(seat)
  }

  formatNumber(floatValue = 1, decimals = 2, multiplier = 1) {
    let floatMultiplied = floatValue * multiplier;
    let stringFloat = floatMultiplied + "";
    let arraySplitFloat = stringFloat.split(".");
    let decimalsValue = "0";
    if (arraySplitFloat.length > 1) {
      decimalsValue = arraySplitFloat[1].slice(0, decimals);
    }
    let integerValue = arraySplitFloat[0];
    let arrayFullStringValue = [integerValue, decimalsValue];
    let FullStringValue = arrayFullStringValue.join(".")
    let floatFullValue = parseFloat(FullStringValue) + "";
    let formatFloatFullValue = new Intl.NumberFormat('de-DE', { minimumFractionDigits: decimals, style: 'currency', currency: 'EUR' }).format(Number(floatFullValue));
    return formatFloatFullValue;
  }


}
